import http from "@/assets/js/common/http-common";

class AssistenteDataService {
  chat(pergunta) {
    return http.post("assistente/chat", { pergunta });
  }
}

export default new AssistenteDataService();
